var app = angular.module('leonardo');

var PortfolioPropertySelector = function ($q, $timeout, PortfolioService, PropertyService, PermissionService,
                                          AuthDataService, $filter, FilterService) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    templateUrl: 'views/templates/widget/portfolio-property-selector.html',
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      onlyProperty: '=?',
      selectAll: '=?',
      search: '=?',
      propertiesAvailable: '=?',
      portfoliosAvailable: '=?',
      label: '@',
      mode: '@',
      name: '@',
      inline: '@',
      account: '=?',
      managedBy: '=?',
      ngRequired: '@',
      allSelected: '=?'
    },
    link: function (scope, element, attrs, ctrls) {

      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.portfolios= [];
      scope.properties = [];
      scope.type = null;
      scope.valid_portfolios = [];
      scope.authDataService = AuthDataService;
      scope.allPortfolios = false;
      scope.init = $q.defer();
      scope.value = null;
      scope.initialized = false;
      scope.all = scope.allSelected || false;
      scope.currentPage = 1;
      scope.limit = 50;
      scope.numberOfPages = function(){
        return Math.ceil(scope.copyPortfolios && scope.copyPortfolios.length/scope.limit);
      };

      scope.searchRecords = function (string) {
        if (string) {
          scope.copyPortfolios = $filter('CustomPortfolioSearch')(scope.portfolios, string);
        }
        else {
          scope.copyPortfolios = scope.portfolios;
        }
      }

      scope.resetRecords = function(){
        scope.searchValue = '';
      }

      scope.setPage = function (page) {
        scope.currentPage = page;
      }

      scope.getAvailable = function(list) {
        var object = list.$object ? list.$object : list;
        return object.results ? object.results : object;
      };

      scope.ngModelCtrl.$render = function () {
        scope.value = scope.ngModelCtrl.$viewValue;
      };

      scope.isAllSelected = function () {
        if (!scope.value) {
          return false;
        }
        if (scope.type) {
          return true;
        }
        if (scope.onlyProperty) {
          return (scope.value.properties.length === scope.properties.length);
        }
        else {
          return (scope.value.properties.length === scope.properties.length) &&
            (scope.value.portfolios.length === scope.portfolios.length);
        }
      };

      scope.portfolioItems = function () {
        var portfolioItems = [];
        angular.forEach(scope.portfolios, function (item) {
          portfolioItems.push(item.id);
        });
        return portfolioItems;
      };

      scope.togglePortfolio = function (portfolio) {
        if (scope.disabled) return;
        if (scope.type) {
          scope.type = null;
        }
        if (!scope.value) scope.value = {portfolios: [], properties: []};
        if (!scope.value.properties) scope.value.properties = [];
        if (!scope.value.portfolios) scope.value.portfolios = [];
        var index = scope.value.portfolios.indexOf(portfolio.id);
        if (index >= 0) {
          scope.value.portfolios.splice(index, 1);
          angular.forEach(scope.properties, function (item) {
            var portfolio_id = (item.portfolio && item.portfolio.id) ? item.portfolio.id : item.portfolio;
            if (portfolio.id === portfolio_id) {
              var index_property = scope.value.properties.indexOf(item.id);
              if(index_property>=0){
                scope.value.properties.splice(index_property, 1);
              }
            }
          });
        }
        else {
          if (scope.allPortfolios) {
            var portfolioItemsTemp = angular.copy(scope.portfolioItems());
            index = portfolioItemsTemp.indexOf(portfolio.id);
            if (index >= 0) {
              portfolioItemsTemp.splice(index, 1);
            }
            scope.allPortfolios = false;
            scope.value.portfolios = portfolioItemsTemp;

          } else {
            scope.value.portfolios.push(portfolio.id);
            angular.forEach(scope.properties, function (item) {
              var portfolio_id = (item.portfolio && item.portfolio.id) ? item.portfolio.id : item.portfolio;
              if (portfolio.id === portfolio_id) {
                var index_property = scope.value.properties.indexOf(item.id);
                if (scope.mode === 'properties') {
                  if (index_property < 0)
                    scope.value.properties.push(item.id);
                }
                else {
                  if (index_property >= 0)
                    scope.value.properties.splice(index_property, 1);
                }
              }
            });
          }

        }
        scope.all = scope.isAllSelected();
        scope.ngModelCtrl.$setViewValue(scope.isValidated() ? scope.value : null);
      };

      scope.toggleProperty = function (property, portfolio) {
        if (scope.disabled) return;
        var portfolioProperties = [];
        angular.forEach(portfolio.properties, function (item) {
          portfolioProperties.push(item.id);
        });
        if (scope.type) {
          scope.type = null;
        }
        if (!scope.value) scope.value = {portfolios: [], properties: []};
        if (!scope.value.properties) scope.value.properties = [];
        if (!scope.value.portfolios) scope.value.portfolios = [];
        var portfolio_id = (property.portfolio && property.portfolio.id) ? property.portfolio.id : property.portfolio;
        var index = scope.value.portfolios.indexOf(portfolio_id);
        /** Remove portfolio if exist **/
        if (index >= 0) {
          scope.value.portfolios.splice(index, 1);
          /** Remove property of the properties of the portfolio**/
          var portfolioPropertiesTemp = angular.copy(portfolioProperties);
          index = portfolioPropertiesTemp.indexOf(property.id);
          if (index >= 0) {
            portfolioPropertiesTemp.splice(index, 1);
            /** If exists properties of other portfolios, they are added to the properties  **/
            if (scope.value.properties.length > 0) {
              angular.forEach(portfolioPropertiesTemp, function (item) {
                if (scope.value.properties.indexOf(item) < 0) {
                  scope.value.properties.push(item);
                }
              });
              index = scope.value.properties.indexOf(property.id);
              if (index >= 0) {
                scope.value.properties.splice(index, 1);
              }
            }
            /** If no exists properties of other portfolios, the properties are the properties of the portfolio **/
            else {
              scope.value.properties = portfolioPropertiesTemp;
            }
          }
        } else {
          if (!scope.value.properties) {
            scope.value.properties = [];
          }
          index = scope.value.properties.indexOf(property.id);
          if (index >= 0) {
            scope.value.properties.splice(index, 1);
          }
          else {
            scope.value.properties.push(property.id);
          }
        }
        if (scope.allPortfolios) {
          var portfolioPropertiesTemp1 = angular.copy(portfolioProperties);
          index = portfolioPropertiesTemp1.indexOf(property.id);
          if (index >= 0) {
            portfolioPropertiesTemp1.splice(index, 1);
          }
          scope.value.properties = portfolioPropertiesTemp1;
          var portfolioItemsTemp = angular.copy(scope.portfolioItems());
          index = portfolioItemsTemp.indexOf(portfolio.id);
          if (index >= 0) {
            portfolioItemsTemp.splice(index, 1);
          }
          scope.value.portfolios = portfolioItemsTemp;
          scope.allPortfolios = false;
          scope.value.type = "";
        }
        scope.all = scope.isAllSelected();
        scope.ngModelCtrl.$setViewValue(scope.isValidated() ? scope.value : null);
      };

      scope.setType = function (type) {
        if (scope.disabled) return;
        scope.allPortfolios = !scope.allPortfolios;
        if (scope.type !== type) {
          scope.type = type;
        }
        else {
          scope.type = null;
        }
        scope.value = {portfolios: [], properties: [], type: scope.type};
        scope.all = scope.isAllSelected();
        if (scope.all) {
          if (!scope.onlyProperty) {
            angular.forEach(scope.portfolios, function (item) {
              scope.value.portfolios.push(item.id);
            });
          }
          angular.forEach(scope.properties, function (item) {
            scope.value.properties.push(item.id);
          });
        }
        scope.ngModelCtrl.$setViewValue(scope.isValidated() ? scope.value : null);
      };

      scope.selectAllProperties = function() {
        if (scope.disabled) return;
        scope.all = !scope.all;
        var value = {portfolios: [], properties: [], type: scope.type, all_portfolios: scope.all};
        if (scope.all) {
          if (!scope.onlyProperty) {
            angular.forEach(scope.portfolios, function (item) {
              value.portfolios.push(item.id);
            });
          }
          angular.forEach(scope.properties, function (item) {
            value.properties.push(item.id);
          });
        }
        scope.value = value;
        scope.ngModelCtrl.$setViewValue(scope.value);
      };

      scope.initProperties = function (noRefresh) {
        if (!isEmpty(scope.propertiesAvailable)) {
          scope.properties = scope.propertiesAvailable;
          scope.all = scope.isAllSelected();
        }
        else {
          var portfolios_available = [];
          if (!isEmpty(scope.portfoliosAvailable)) {
            angular.forEach(scope.portfolios, function (portfolio) {
              portfolios_available.push(portfolio.id ? portfolio.id : portfolio);
            });
          }
          scope.properties = PropertyService.getlist({
            disable_pagination: true,
            essential: true,
            account: scope.account,
            managed_by: scope.managedBy,
            portfolio__id: !isEmpty(portfolios_available) ? portfolios_available.join(',') : null
          }, true);
        }
        $q.when(scope.properties).then(function (list) {
          scope.portfoliosAvailable = !isEmpty(scope.portfoliosAvailable) ? scope.getAvailable(scope.portfoliosAvailable) : null;
          scope.propertiesAvailable = !isEmpty(scope.propertiesAvailable) ? scope.getAvailable(scope.propertiesAvailable) : null;
          scope.properties = list.results ? list.results : list;
          var portfolios_property_ids = [];
          angular.forEach(scope.properties, function(item) {
            if (isNull(item.available_for_invitation) || item.available_for_invitation) {
              var portfolio_id = (item.portfolio && item.portfolio.id) ? item.portfolio.id : item.portfolio;
              if (!isNull(portfolio_id) && !_.contains(portfolios_property_ids, portfolio_id)) {
                portfolios_property_ids.push(portfolio_id);
              }
            }
          });
          var portfolios_ids = [];
          angular.forEach(scope.portfolios, function(item){
            if (!_.contains(portfolios_ids, item.id ? item.id : item)) {
              portfolios_ids.push(item.id);
            }
          });
          var exist = true;
          angular.forEach(portfolios_property_ids, function (id) {
            if (!_.contains(portfolios_ids, id)) {
              exist = false;
              portfolios_ids.push(id);
            }
          });
          if (!exist && !noRefresh) {
            PortfolioService.getlist({disable_pagination: true, essential: true, id: portfolios_ids.join(',')}).then(function(list) {
              scope.portfolios = list.results ? list.results : list;
              scope.initProperties(true);
            });
          }
          else {
            angular.forEach(scope.properties, function (item) {
              if (isNull(item.available_for_invitation) || item.available_for_invitation)
                angular.forEach(scope.portfolios, function (value) {
                  var portfolio_id = (item.portfolio && item.portfolio.id) ? item.portfolio.id : item.portfolio;
                  if (value.id == portfolio_id) {
                    if (!value.properties) {
                      value.properties = [];
                    }
                    value.properties.push(item);
                  }
                });
            });
            if (scope.mode === 'properties' || !scope.portfoliosAvailable) {
              var index = scope.portfolios.length - 1;
              while (index >= 0) {
                if (isEmpty(scope.portfolios[index].properties)) {
                  if (scope.value && scope.value.portfolios) {
                    var indexValue = scope.value.portfolios.indexOf(scope.portfolios[index].id);
                    if (indexValue >= 0) {
                      scope.value.portfolios.splice(indexValue, 1);
                    }
                  }
                  scope.portfolios.splice(index, 1);
                }
                index -= 1;
              }
            }
            scope.valid_portfolios = [];
            let currentAccountPortfolios = $filter('filter')(FilterService.portfolios, {
              account: scope.account,
            });

            angular.forEach(currentAccountPortfolios, function (value) {
              scope.valid_portfolios.push(value.id);
            });
            scope.init.resolve();
            scope.initialized = true;
          }
          scope.all = scope.isAllSelected();
          scope.removeInvalidPortfolios();
          scope.copyPortfolios = angular.copy(scope.portfolios);
        });
      };

      scope.showAccount = function () {
        return PermissionService.isOwner(scope.account_user) && !scope.portfoliosAvailable && !scope.propertiesAvailable;
      };

      scope.showPortfolios = function (portfolio) {
        var show = (_.contains(scope.valid_portfolios, portfolio.id));
        if (!isNull(portfolio.available_for_invitation) && !portfolio.available_for_invitation) {
          show = false;
        }
        else if (!scope.portfoliosAvailable && scope.propertiesAvailable) {
          show = false;
        }
        else if (scope.portfoliosAvailable) {
          var exist = false;
          angular.forEach(scope.portfoliosAvailable, function (available) {
            if (portfolio.id == available.id) {
              exist = true;
            }
          });
          show = exist;
        }
        else if (PermissionService.isOwner(scope.account_user)) {
          show = true;
        }
        return show;
      };

      scope.removeInvalidPortfolios = function () {
        angular.forEach(scope.portfolios, function (portfolio) {
          if (!scope.showPortfolios(portfolio)) {
            if (scope.value && scope.value.portfolios) {
              var index = scope.value.portfolios.indexOf(portfolio.id);
              if (index >= 0) {
                scope.value.portfolios.splice(index, 1);
              }
            }
          }
        });
      };

      scope.isPortfolioSelected = function(portfolio) {
        return !isNull(scope.type) || (scope.value && _.contains(scope.value.portfolios, portfolio.id));
      };

      scope.isPortfolioDisabled = function() {
        return !isNull(scope.type) || scope.disabled;
      };

      scope.isPropertySelected = function(property) {
        var portfolio_id = (property.portfolio && property.portfolio.id) ? property.portfolio.id : property.portfolio;
        return !isNull(scope.type) || (scope.value && (_.contains(scope.value.properties, property.id) ||
          (_.contains(scope.value.portfolios, portfolio_id))));
      };

      scope.isPropertyDisabled = function(property) {
        var portfolio_id = (property.portfolio && property.portfolio.id) ? property.portfolio.id : property.portfolio;
        return !isNull(scope.type) || (scope.value && _.contains(scope.value.portfolios, portfolio_id)) || scope.disabled;
      };

      scope.portfolios = !isEmpty(scope.portfoliosAvailable) ? scope.portfoliosAvailable :
        PortfolioService.getlist({
          disable_pagination: true,
          essential: true,
          account: scope.account,
          managed_by: scope.managedBy
        });

      $q.when(scope.portfolios).then(function (data) {
        scope.portfolios = data.results ? data.results : data;
        scope.initProperties();
      });

      scope.$watch('account', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          PortfolioService.getlist({
            disable_pagination: true,
            essential: true,
            account: newValue,
            managed_by: scope.managedBy
          }).then(function (data) {
            scope.portfolios = data.results ? data.results : data;
            scope.initProperties();
          });
        }
      });

      scope.$watch('value', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.all = scope.isAllSelected();
        }
      });

      scope.$watch('searchValue', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          scope.searchRecords(newValue);
        }
      });
      
      scope.$on('select-properties-all:updated', function () {
        $q.when(scope.init.promise).then(function () {
          var value = {portfolios: [], properties: [], type: scope.type};
          angular.forEach(scope.portfolios, function (item) {
            value.portfolios.push(item.id);
          });
          angular.forEach(scope.properties, function (item) {
            value.properties.push(item.id);
          });
          scope.ngModelCtrl.$setViewValue(value);
        });
      });

      scope.isValidated = function() {
        if (!scope.required) {
          return true;
        }
        if (isNull(scope.value)) {
          return false;
        }
        return (!isNull(scope.value.type) ||
          (scope.value.portfolios && scope.value.portfolios.length > 0) ||
          (scope.value.properties && scope.value.properties.length > 0)
        );
      };

    }
  };
};

app.directive('portfolioPropertySelector', ['$q', '$timeout', 'PortfolioService', 'PropertyService',
  'PermissionService', 'AuthDataService', '$filter', 'FilterService', PortfolioPropertySelector]);

